module.exports = __webpack_public_path__ + "static/media/instantEFT.bf8a5db5.svg";